import state from './clipboard.state'
import mutations from './clipboard.mutations'
import actions from './clipboard.actions'
import getters from './clipboard.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/clipboard/clipboard.module.js
// module id = null
// module chunks = 